export default __webpack_public_path__ + "static/40-3dcc59ad497f632777df3d579c3e27fd.png";